import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const SaveDetailsPopup = (props) => {
  return (
    <Modal show={props.show} onHide={props.onHide} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Projekt erstellen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Sie müssen zuerst die Details für das Projekt speichern!{" "}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
